// ABOUTME: Loads configured access checks for all visible role data scopes in one query.
// ABOUTME: Keeps role components independent from individual data-scope implementations.

import {useQuery} from '@tanstack/react-query'

import {getDataScopeAccessMap} from '../modules/DataScopeAccess'
import {DataScopes, GroupedRoleAssignment} from '../modules/ManageUsers.selectors'

const FIVE_MINUTES_MS = 5 * 60 * 1000

const normalizeDataScopes = (dataScopes: DataScopes): DataScopes =>
  Object.fromEntries(
    Object.entries(dataScopes)
      .sort(([leftName], [rightName]) => leftName.localeCompare(rightName))
      .map(([name, value]) => [name, Array.isArray(value) ? [...value].sort() : value])
  )

export const useRolesDataScopeAccess = (roles: GroupedRoleAssignment[]) => {
  const dataScopes = roles
    .map((role) => normalizeDataScopes(role.commonDataScopes))
    .sort((left, right) => JSON.stringify(left).localeCompare(JSON.stringify(right)))
  const dataScopesKey = JSON.stringify(dataScopes)

  return useQuery(
    ['roleDataScopeAccess', dataScopesKey],
    () => getDataScopeAccessMap(dataScopes),
    {
      enabled: roles.length > 0,
      retry: false,
      staleTime: FIVE_MINUTES_MS,
      refetchOnWindowFocus: false
    }
  )
}